var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNavigationArrow = function SvgIconNavigationArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "m1.5 1 4 4-4 4",
    stroke: "#fff",
    strokeWidth: 1.27,
    strokeLinecap: "square"
  })));
};
export default SvgIconNavigationArrow;